module.exports = __webpack_public_path__ + "946bb62e7e052ff9182e955204ac84b4.svg";